(() => {
  'use strict';
  const node = document.getElementById('cs-halloween-config');
  if (!node || window.CorkSpaceHalloween) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch { return; }
  const end = Date.parse(config.endsAt);
  const active = () => Date.now() < end;
  let expired = false;
  function expire() {
    if (active() || expired) return;
    expired = true;
    document.documentElement.classList.remove('cs-halloween-active');
    document.querySelectorAll('[data-hw-banner],.cs-hw-offer,.cs-sale-hero,.cs-sale-badge:not(.cs-sale-badge--unavailable),.cs-sale-saving,.cs-sale-digital,.cs-sale-digital-detail,.cs-hw-widget-banner').forEach(el=>el.style.setProperty('display','none','important'));
    document.querySelectorAll('.cs-hw-cart-offer').forEach(el=>el.remove());
    document.querySelectorAll('.cs-hw-cart-upsell').forEach(el=>el.classList.remove('cs-hw-cart-upsell'));
    const key = `corkspace:halloween-expired:${config.endsAt}`;
    let reload = false;
    try { reload = sessionStorage.getItem(key) !== '1'; sessionStorage.setItem(key,'1'); } catch {}
    if (reload) window.location.reload();
  }
  window.setTimeout(expire,Math.min(Math.max(0,end-Date.now()),2147483647));
  window.addEventListener('pageshow',()=>{if(!active())expire();});
  document.addEventListener('visibilitychange',()=>{if(!document.hidden && !active())expire();});
  setInterval(()=>{if(!active())expire();},15000);
  if (!active()) { expire(); return; }
  const mats = new Set(config.matProductIds.map(String));
  const root = window.Shopify?.routes?.root || '/';
  const baseFetch = window.fetch.bind(window);
  const rate = config.currency === 'GBP' ? 1 : Number(window.Shopify?.currency?.rate);
  if (!Number.isFinite(rate) || rate <= 0) return;
  const savingCents = Math.round(5000 * rate);
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:config.currency,minimumFractionDigits:0,maximumFractionDigits:2}).format(cents / 100);
  const saving = money(savingCents);
  let cart = null;
  let scheduled = false;
  let refreshPending = false;
  let eligibilityKey = null;
  function setText(element, text) { if (element && element.textContent !== text) element.textContent = text; }
  function render() {
    if (!active()) return;
    document.querySelectorAll('.cs-hw-offer--cart').forEach(el=>el.remove());
    document.querySelectorAll('[data-hw-sale-eligibility]').forEach(el=>setText(el,`Buy any new mat with a Yoga Space plan in the same order. Save ${saving} on one plan per order. Accessories alone don’t qualify.`));
    document.querySelectorAll('[data-hw-widget-banner]').forEach(banner=>{setText(banner,`Save extra ${saving} with any mat`);banner.hidden=false;});
    if (String(config.productId) === String(config.digitalProductId)) {
      const target=document.querySelector('.product__info-container');
      if (target && !target.querySelector('.cs-hw-offer--product')) {
        const box=document.createElement('aside'); box.className='cs-hw-offer cs-hw-offer--product';
        const heading=document.createElement('h3'); heading.textContent=`Extra ${saving} off with any new mat`; box.append(heading);
        const price=target.querySelector('[id^="price-"]');
        if(price) price.insertAdjacentElement('afterend',box); else target.prepend(box);
      }
    }
    if (!cart) return;
    const hasMat=cart.items?.some(i=>mats.has(String(i.product_id)));
    const hasPlan=cart.items?.some(i=>String(i.product_id)===String(config.digitalProductId));
    const nextEligibilityKey = `${Boolean(hasMat)}:${Boolean(hasPlan)}`;
    if (nextEligibilityKey !== eligibilityKey) { eligibilityKey = nextEligibilityKey; window.dispatchEvent(new Event('corkspace:halloween-cart')); }
    document.querySelectorAll('#cart-drawer-app .cd-cart-upsell-item').forEach(item=>{
      if(!item.querySelector('a[href*="/products/yogaspace"]')) return;
      const showOffer=!hasPlan;
      item.classList.toggle('cs-hw-cart-upsell',showOffer);
      let badge=item.querySelector('.cs-hw-cart-offer');
      if(!showOffer){badge?.remove();return;}
      if(!badge){
        const title=item.querySelector('.cd-cart-upsell-item-title');
        if(!title) return;
        badge=document.createElement('span'); badge.className='cs-hw-cart-offer';
        title.insertAdjacentElement('afterend',badge);
      }
      setText(badge,`You Save ${saving} Off with any Mat`);
    });
  }
  function schedule(){if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;render();});}
  async function refresh(){
    if(refreshPending || !active())return; refreshPending=true;
    try{const r=await baseFetch(`${root}cart.js`,{cache:'no-store',headers:{Accept:'application/json'}});if(r.ok){const next=await r.json();if(next.currency===config.currency)cart=next;schedule();}}catch{}finally{refreshPending=false;}
  }
  window.fetch=function(input,options){
    const response=baseFetch(input,options);
    const url=typeof input==='string'?input:input?.url || '';
    if(/\/cart\/(add|change|update|clear)(\.js)?(?:[?#]|$)/.test(url))response.then(r=>{if(r.ok)window.setTimeout(refresh,100);}).catch(()=>{});
    return response;
  };
  window.addEventListener('cartix:cartUpdated',event=>{const next=event.detail?.cart;if(next?.currency===config.currency){cart=next;schedule();}else refresh();});
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)refresh();});
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  window.CorkSpaceHalloween={refresh, bundlePrice(variant) {
    if (!active() || !cart?.items?.some(i=>mats.has(String(i.product_id))) || cart.items.some(i=>String(i.product_id)===String(config.digitalProductId))) return null;
    return Math.max(0,Number(variant.price)-savingCents);
  }};
  refresh();render();
})();
